import React from "react";
import TableCell from "@material-ui/core/TableCell";
import { formatCurrency, formatRate, formatDate } from "components/Global/Metric/formattersv2";

const EMPTY_VALUE = "--";

const PropertiesTableColumns = () => [
  {
    id: "dealName",
    label: "Deal",
    numeric: false,
    isString: true,
    isDateField: false,
    isBaseColumn: true,
    dataField: "dealName",
    Cell: ({ data }) => (
      <TableCell id={`deal${data.propertyId}`}>{data.dealName}</TableCell>
    )
  },
  {
    id: "property",
    label: "Property",
    numeric: false,
    isString: true,
    isDateField: false,
    dataField: "property",
    Cell: ({ data }) => (
      <TableCell id={`property${data.propertyId}`}>{data.property}</TableCell>
    )
  },
  {
    id: "updatedOn",
    label: "Updated On",
    numeric: false,
    isString: false,
    isDateField: true,
    dataField: "updatedOn",
    Cell: ({ data }) => (
      <TableCell id={`updatedOn${data.propertyId}`}>{data.updatedOn ? formatDate(data.updatedOn) : EMPTY_VALUE}</TableCell>
    )
  },
  {
    id: "noiLender",
    label: "NOI Lender",
    numeric: true,
    isString: false,
    isDateField: false,
    dataField: "noiLender",
    Cell: ({ data }) => (
      <TableCell id={`noiLender${data.propertyId}`}>{data.noiLender ? formatCurrency(data.noiLender) : EMPTY_VALUE}</TableCell>
    )
  },
  {
    id: "noiActual",
    label: "NOI Actual",
    numeric: true,
    isString: false,
    isDateField: false,
    dataField: "noiActual",
    Cell: ({ data }) => (
      <TableCell id={`noiActual${data.propertyId}`}>{data.noiActual ? formatCurrency(data.noiActual) : EMPTY_VALUE}</TableCell>
    )
  },
  {
    id: "occupancy",
    label: "Occupancy",
    numeric: true,
    isString: false,
    isDateField: false,
    dataField: "occupancy",
    Cell: ({ data }) => (
      <TableCell id={`occupancy${data.propertyId}`}>{data.occupancy ? formatRate(data.occupancy) : EMPTY_VALUE}</TableCell>
    )
  },
  {
    id: "marketValue",
    label: "Market Value",
    numeric: true,
    isString: false,
    isDateField: false,
    dataField: "marketValue",
    Cell: ({ data }) => (
      <TableCell id={`marketValue${data.propertyId}`}>{data.marketValue ? formatCurrency(data.marketValue) : EMPTY_VALUE}</TableCell>
    )
  },
  {
    id: "methodology",
    label: "Methodology",
    numeric: false,
    isString: true,
    isDateField: false,
    dataField: "methodology",
    Cell: ({ data }) => (
      <TableCell id={`methodology${data.propertyId}`}>{data.methodology ? data.methodology : EMPTY_VALUE}</TableCell>
    )
  },
  {
    id: "lastUpdatedBy",
    label: "Last Updated By",
    numeric: false,
    isString: true,
    isDateField: false,
    dataField: "lastUpdatedByContactName",
    Cell: ({ data }) => (
      <TableCell id={`lastUpdatedByContact${data.propertyId}`}>{data.lastUpdatedByContact ? `${data.lastUpdatedByContact.firstName} ${data.lastUpdatedByContact.lastName}` : EMPTY_VALUE}</TableCell>
    )
  }
];

export default PropertiesTableColumns;
